import { ListingSort } from '@df/catalog-ui/listing/sort/listing-sort';
import { Model } from '@df/catalog/model';
import { IProductDataV2 } from '@df/catalog/product/product';
import { NgInject } from '@df/ng/ng-inject';
import { KlevuSearchService } from '../../../../module/klevu-search/klevu-search.service.decorator';
import { Product } from '../../../product/product.decorator';

export class LocalListingSort<T extends Model = Model> extends ListingSort<T> {
    @NgInject(KlevuSearchService)
    klevuSearchService!: KlevuSearchService;
    /**
     * Sorts collection by currently selected sort option
     * More then one sortOption is allowed
     *
     * @param  {Model[]} collection input collection
     * @return {Model}              sorted collection
     */
    override applySort(collection: T[], cb: (models: T[]) => void): void {
        const sourceModel = this.listing.config.source;
        if (sourceModel.type === 'category' && sourceModel.verbosity >= 3) {
            this.applyKlevuSortFilter(collection, cb, sourceModel);
        } else {
            this.applySelection(collection, cb);
        }
    }

    applySelection(collection: T[], cb: (models: T[]) => void): void {
        const selection = this.getSelection();
        if (selection) {
            const engineName = selection.engine || 'attribute';
            const engine = ListingSort.engines[engineName];

            if (engine) {
                engine.sort(collection, selection, this.listing, (models: T[]) => {
                    // only apply if still the same option
                    if (selection === this.getSelection()) {
                        cb(models);
                    }
                });
                return;
            } else {
                console.warn('Missing sort engine for sort option: ', engineName);
            }
        }

        cb(collection);
    }

    applyKlevuSortFilter(collection: T[], cb: (models: T[]) => void, sourceModel: any): void {
        this.klevuSearchService
            .sendCategoryExclusions(sourceModel)
            .then(filterFunction => {
                this.applySelection(filterFunction(collection as any as Product<IProductDataV2>[]) as any as T[], cb);
            })
            .catch(() => {
                this.applySelection(collection, cb);
            });
    }
}
